import styled from '@emotion/styled'
import { Text, FormValue, FieldProps, FormValues } from 'informed'
import React from 'react'

import { overrideOptional } from '@emico/overrides'
import { maxWidth } from '@emico/styles'

// Input does not support passing a label for buttons
// It also isn't intended for buttons
// So type='button' or type='submit' should not be allowed.
// A button component should be used instead
type InputTypes =
  | 'checkbox'
  | 'color'
  | 'date'
  | 'datetime-local'
  | 'email'
  | 'file'
  | 'hidden'
  | 'image'
  | 'month'
  | 'number'
  | 'password'
  | 'radio'
  | 'range'
  | 'reset'
  | 'search'
  | 'tel'
  | 'text'
  | 'time'
  | 'url'
  | 'week'

type Props = Omit<FieldProps<FormValue, FormValues>, 'type'> & {
  type?: InputTypes
}

const TextInput = (props: Props) => <Text {...props} />

export const StyledTextInput = styled(TextInput)`
  font-size: 12px;
  // Font-size on mobile devices should at least be 16px. This makes
  // it so that you are at least forces to think about it.
  @media ${maxWidth('sm')} {
    font-size: 16px;
  }
`

const Input = ({ ...props }: Props) => <StyledTextInput {...props} />

export default overrideOptional(Input)
